import { blue, neutral, Text } from "@flat-ui";
import { Box, Grid2 } from "@mui/material";
import { ExporterApp } from "@pages/settings/export-workspace/exporter-app";
import { GetExportDataToken } from "@pages/settings/export-workspace/get-export-data-token";
import { FaroCoreApiTypes } from "@stellar/core-api-client";
import { CommonStyles } from "@styles/common-styles";

interface Props {
  /** The name of the entity to export (workspace or project) */
  entityName: "workspace" | "project";

  /** The IDs of the projects to export. If not provided, all projects will be exported. */
  projectIds?: FaroCoreApiTypes.ProjectId[];
}

/** Allows users to get a token to export/download the workspace data */
export function ExportWorkspaceOrProjects({
  entityName,
  projectIds,
}: Props): JSX.Element {
  return (
    <Box
      data-testid="workspace-settings-export-workspace"
      sx={{
        mt: "24px",
        backgroundColor: neutral[50],
        borderRadius: "8px",
        padding: "50px",
      }}
    >
      <Text variant="heading24" component="div" color={blue[400]}>
        Let's export your {entityName}
      </Text>
      <Text
        variant="bodyL"
        component="div"
        color={neutral[600]}
        sx={{
          marginTop: "8px",
          paddingBottom: "32px",
          borderBottom: CommonStyles.Borders.gray200Divider,
        }}
      >
        Download the code and the app. Open the app and follow the instructions
        to start your export.
      </Text>
      <Grid2
        container
        spacing={2}
        sx={{
          mt: "32px",
          alignItems: "center",
          justifyContent: {
            xs: "left",
            md: "space-between",
          },
        }}
      >
        <Grid2
          size={{
            xs: 12,
            md: "auto",
          }}
        >
          <GetExportDataToken projectIds={projectIds} />
        </Grid2>
        <Grid2
          size={{
            xs: 12,
            md: "grow",
          }}
        >
          <ExporterApp
            direction={{
              xs: "column",
              md: "row",
            }}
          />
        </Grid2>
      </Grid2>
    </Box>
  );
}
